import React, { useEffect, useState } from "react";
import api from "../api/api";
import "../styles/testimonials.css";

export default function Testimonials() {

  const [testimonials, setTestimonials] = useState([]);
  const [index, setIndex] = useState(0);
  const [status, setStatus] = useState("loading");
  // loading | success | empty | error

  // ==========================================================
  // FETCH TESTIMONIALS FROM API
  // ==========================================================
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {

        const res = await api.get("testimonials/");
        console.log("API Response:", res.data);

        if (res.data && res.data.length > 0) {
          setTestimonials(res.data);
          setStatus("success");
        } else {
          setStatus("empty");
        }

      } catch (error) {
        console.error("Testimonials API Error:", error);
        setStatus("error");
      }
    };

    fetchTestimonials();
  }, []);

  // ==========================================================
  // AUTO SLIDER
  // ==========================================================
  useEffect(() => {

    if (status !== "success") return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);

  }, [testimonials, status]);

  // ==========================================================
  // RENDER
  // ==========================================================
  return (
    <section className="testimonial-section">

      {/* LOADING */}
      {status === "loading" && (
        <p className="testimonial-loading">
          Loading Testimonials...
        </p>
      )}

      {/* ERROR */}
      {status === "error" && (
        <p className="testimonial-loading">
          Failed to load testimonials
        </p>
      )}

      {/* EMPTY */}
      {status === "empty" && (
        <p className="testimonial-loading">
          No Testimonials Found
        </p>
      )}

      {/* SUCCESS */}
      {status === "success" && testimonials.length > 0 && (
        <>
          <div className="testimonial-card">

            <div className="quote-icon">❝</div>

            {/* IMAGE */}
            {(testimonials[index].image || testimonials[index].photo_url) && (
              <img
                src={testimonials[index].image || testimonials[index].photo_url}
                alt={testimonials[index].name}
                className="testimonial-img"
              />
            )}

            {/* MESSAGE */}
            <p className="testimonial-message">
              “{testimonials[index].message}”
            </p>

            {/* RATING */}
            <div className="testimonial-stars">
              {Array.from({
                length: testimonials[index].rating || 5,
              }).map((_, i) => (
                <span key={i}>⭐</span>
              ))}
            </div>

            {/* NAME */}
            <h4 className="testimonial-name">
              {testimonials[index].name}
            </h4>

            {/* ROLE / DESIGNATION */}
            {(testimonials[index].role || testimonials[index].designation) && (
              <p className="testimonial-role">
                {testimonials[index].role || testimonials[index].designation}
              </p>
            )}

          </div>

          {/* DOT NAVIGATION */}
          <div className="testimonial-dots">
            {testimonials.map((_, i) => (
              <span
                key={i}
                className={
                  i === index
                    ? "testimonial-dot active-dot"
                    : "testimonial-dot"
                }
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </>
      )}

    </section>
  );
}